<template>
  <div class="font-general flex min-h-screen flex-col bg-gradient-to-br from-primary-light via-secondary-light to-ternary-light dark:from-primary-dark dark:via-secondary-dark dark:to-ternary-dark">
    <!-- Background pattern -->
    <div class="fixed inset-0 opacity-30 dark:opacity-20">
      <div class="absolute inset-0" style="background-image: radial-gradient(circle at 1px 1px, rgba(59, 130, 246, 0.15) 1px, transparent 0); background-size: 20px 20px;" />
    </div>

    <div class="relative z-10">
      <AppHeader />
      <main class="min-h-screen flex-1">
        <slot />
      </main>
      <AppFooter />
    </div>

    <div class="fixed bottom-0 right-0 z-50 mb-6 mr-8 flex items-center space-x-2 sm:space-x-4">
      <BackToTop />
    </div>
    <ClientOnly>
      <Notifications />
    </ClientOnly>
  </div>
</template>

<script>
import BackToTop from '../components/BackToTop.vue'
import AppFooter from '../components/Layout/AppFooter.vue'
import AppHeader from '../components/Layout/AppHeader.vue'
import Notifications from '../components/Layout/Notifications.vue'

export default {
  components: { AppFooter, BackToTop, AppHeader, Notifications },
}
</script>

<style>
.vue-back-to-top {
  @apply p-2 sm:p-4 bg-indigo-500 hover:bg-indigo-600 text-white;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
}

.fade-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideInUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-leave-active {
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideOutDown 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.98);
    filter: blur(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
}

@keyframes slideOutDown {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20px) scale(0.98);
    filter: blur(1px);
  }
}
</style>
